import { Speaker } from '@app/shared/models/app.model';

/** Auris event name for live transcript broadcasts. */
export const TRANSCRIPT_UPDATE = 'transcript.update';

/** Payload of a `transcript.update` event (mirrors the Firestore doc shape). */
export interface TranscriptUpdatePayload {
  id: string;
  is_final: boolean;
  confidence: number;
  language: string;
  message: string;
  /** target_lang -> translated text; omitted when there are no translations. */
  transcripts?: { [lang: string]: string };
  /** string when diarized, number otherwise. */
  micId: number | string;
  micColor: { hex: string; name: string };
  /** populated only when diarization is active. */
  speaker?: Speaker;
  /** RFC3339; stable across intermediates + final. */
  created_at: string;
  /** RFC3339; changes per event. */
  updated_at?: string;
  /** Unix ms. */
  timestamp: number;
}

/** The `events.Event` wrapper the proxy publishes on the wire. */
export interface TranscriptWsEnvelope {
  event: string;
  created_at?: string;
  payload?: any; // narrowed at the call site after discriminating on `event`
}
